import Vue from 'vue';
import VueI18n from 'vue-i18n';
import messages from '@/lang/de';
import axios from 'axios';

Vue.use(VueI18n);

const DEFAULT_LANG = 'de';

export const i18n = new VueI18n({
  dateTimeFormats: {
    de: {
      short: {
        year: 'numeric', month: 'numeric', day: 'numeric'
      },
      long: {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric'
      }
    }
  },
  locale: process.env.VUE_APP_I18N_LOCALE || DEFAULT_LANG,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || DEFAULT_LANG,
  messages // set locale messages
});

const loadedLanguages = [DEFAULT_LANG]; // our default language that is preloaded

function setI18nLanguage (lang) {
  i18n.locale = lang;
  axios.defaults.headers.common['Accept-Language'] = lang;
  document.querySelector('html').setAttribute('lang', lang);
  return lang;
}

export function loadLanguageAsync (lang = DEFAULT_LANG) {
  // If lang empty
  if (!lang) {
    return Promise.resolve(setI18nLanguage(process.env.VUE_APP_I18N_FALLBACK_LOCALE || DEFAULT_LANG));
  }

  // If the same language
  if (i18n.locale === lang) {
    return Promise.resolve(setI18nLanguage(lang));
  }

  // If the language was already loaded
  if (loadedLanguages.includes(lang)) {
    return Promise.resolve(setI18nLanguage(lang));
  }

  // If the language hasn't been loaded yet
  return import('@/lang/' + lang + '.js').then(
    messages => {
      i18n.setLocaleMessage(lang, messages.default);
      loadedLanguages.push(lang);
      return setI18nLanguage(lang);
    }
  ).catch(e => {
    return setI18nLanguage(process.env.VUE_APP_I18N_FALLBACK_LOCALE || DEFAULT_LANG);
  });
}
